//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/AME.js";
import "../no/Builder.js";
let d=[[[0,"TiaPortalVersion",1,0]],[[[],"ClearExternalLibraryAliases",{},0,0],[["libraryAlias","filePath"],"AddExternalLibraryAlias",{},2,0],[[],"GetExternalLibraryAliasCount",{R_:{count:''}},0,0],[["index","libraryAlias","filePath"],"GetExternalLibraryAlias",{},1,0]],[]];
SPLM.AME.TiaPortalProjectSettingsBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.AME.TiaPortalProjectSettingsBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.AME.TiaPortalProjectSettingsBuilder.TiaPortalVersionType = Object.freeze({
    "V14Sp1" : "V14Sp1", "V15" : "V15", "V151" : "V151", "V16" : "V16", "V17" : "V17", "V18" : "V18", "V19" : "V19"});

export default SPLM;